module.exports = __webpack_public_path__ + "img/lluvia_blue.ff9e863b.svg";